// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__12y_2","subheader":"ReorderModal_subheader__3aYb_","listWrap":"ReorderModal_listWrap__19fWb"};